import { render, staticRenderFns } from "./diploma.vue?vue&type=template&id=376e5b8e&"
import script from "./diploma.vue?vue&type=script&lang=js&"
export * from "./diploma.vue?vue&type=script&lang=js&"
import style0 from "./diploma.vue?vue&type=style&index=0&id=376e5b8e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports